export enum ActiveReturnMode {
  /**
   * Default
   */
  TOTAL_RETURN = 'Total Return',
  ACTIVE_RETURN = 'Active Return',
  EXCESS_RETURN = 'Excess Return',
}
